import {
    createSelector,
} from 'reselect';

import {
    extractTemplate,
} from 'wanderu-utils';

import {
    selectAppStateSlice,
} from '../../selectors';
import NAMESPACE from './types';

const HIDE_AFTER_INDEX = 2;

function getCarrierContactData(appState, locale) {
    return selectAppStateSlice(appState)[NAMESPACE][locale];
}

function getCarrierContactContent(appState, locale) {
    const carrierContactData = getCarrierContactData(appState, locale);
    return carrierContactData && carrierContactData.translations;
}

function getRegionalData(appState, locale) {
    const carrierContactData = getCarrierContactData(appState, locale);
    return carrierContactData && carrierContactData.data;
}

function getLongFormContent(appState, placeGuideId) {
    const placeGuideContent = getCarrierContactContent(appState, placeGuideId);
    return extractTemplate(placeGuideContent);
}

function mapRegionNames(regionalData) {
    if (!regionalData) {
        return;
    }

    return regionalData.map((data, index) => ({
        text: data.country_name,
        id: data.contact_country_code,
        isHidden: index > HIDE_AFTER_INDEX,
    }));
}

// no particular mapping needed here
const selectContent = getCarrierContactContent;
const selectLongFormContent = getLongFormContent;
const selectRegionalData = getRegionalData;

const selectCarrierContactRegions = createSelector(
    getRegionalData,
    mapRegionNames,
);

export {
    selectCarrierContactRegions,
    selectContent,
    selectLongFormContent,
    selectRegionalData,
};
